<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
// import {Chrome} from 'vue-color'
import ClickOutside from 'vue-click-outside'
// import { filter } from 'minimatch'
library.add(fas, fab);

export default {
    name: "VueIconPicker",
    directives: {
        ClickOutside
    },
    props: {
        value: {
            type: Object,
            default: function(){return {name:"flag",type:"fontawesome",color:"#000000"}}
        },
        formField: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '300px'
        },
        inputName: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            search: '',
            icons: {...fas, ...fab},
            icon: null,
            color: {},
            colorPickerPosition: null,
            showIconPicker: false,
            popupItem: null,
            selectedIconName: "",
        }
    },
    computed: {
        filteredIcons: function () {
            return Object
                .keys(this.icons)
                .filter(key => key !== 'faFontAwesomeLogoFull' && this.icons[key].iconName.includes(this.search))
                .map(key => this.icons[key]);
        },
    },
    watch: {
        icon: function (value) {
            this.$emit('input', value ? {...this.value, name: value.iconName, type: 'fontawesome'} : null);
        },
        color: function (value) {
            let val = this.value;
            if (value.hex && val){
                val.color = value.hex;
            }else if (val){
                delete val.color;
            }
            this.$emit('input', val)
        }
    },
    mounted: function () {
        this.popupItem = this.$el;
        this.selectedIconName = this.formField ? this.formField : this.selectedIconName
        try {
            this.icon = this.icons[Object.keys(this.icons).find(icon => this.icons[icon].iconName === this.formField ? this.formField : this.value.name)];
            this.color = {hex: this.value.color};
            this.scrollToSelected();
            // eslint-disable-next-line
        } catch (e) {
        }
    },
    methods: {
        scrollToSelected: function () {
            try {
                this.$refs.list.getElementsByClassName('selected')[0].scrollIntoView();
                // eslint-disable-next-line
            } catch (e) {
            }
        },
        isSelected: function (icon) {
            return this.value && icon.iconName === this.value.name && this.value.type === 'fontawesome';
        },
        resetValue: function () {
            this.icon = null;
            this.color = {};
            this.selectedIconName = ""
            this.colorPickerPosition = null;
        },
        toggleColorPicker: function (e) {
            this.colorPickerPosition = this.colorPickerPosition ? null : {
                position: 'absolute',
                zIndex: 9999,
                top: `${e.pageY}px`,
                left: `${e.pageX}px`,
            }
        },
        hideColorPicker: function () {
            this.colorPickerPosition = null;
        },
        updateSelectedIcon(filteredIcon){      
            this.icon = filteredIcon
            this.selectedIconName = filteredIcon ? filteredIcon.iconName : ''
        },
        changeIconFromInput(){
            this.search = this.selectedIconName
            this.showIconPicker = true
        }
    },
}
</script>
<template>
    <div>
        <form-group :name="inputName" :label="$t(`${label}`)">
            <b-input-group>
                <template v-if="value ? value.name : false" v-slot:prepend>
                    <FontAwesomeIcon v-if="icon" :icon="icon.iconName" class="icon-preview" :style="{ color: '#495057' }"/>
                </template>
                <b-form-input
                    v-model="selectedIconName"
                    slot-scope="{ attrs, listeners }"
                    placeholder="Buscar icono por nombre..."
                    v-bind="attrs"
                    v-on="listeners"
                    @input="changeIconFromInput"
                />
                <template v-slot:append>
                    <b-input-group-text
                        style="cursor:pointer"
                        @click="showIconPicker = !showIconPicker"
                        >
                        <FontAwesomeIcon v-if="!showIconPicker" icon="search" />
                        <FontAwesomeIcon v-else icon="chevron-up" />
                    </b-input-group-text>
                </template>
            </b-input-group>
        </form-group>
        <!--<div v-if="showIconPicker" v-click-outside="hideColorPicker" class="search">
            <div @click="toggleColorPicker($event)">
                <FontAwesomeIcon v-if="icon" :icon="icon.iconName" class="icon-preview" :style="{ color: color.hex }"/>
            </div> -->
            <!-- <b-form-input
                v-model="search"
                placeholder="Search icons by name"
                /> -->
                <!-- @keyup="scrollToSelected" -->

            <!-- <div v-show="colorPickerPosition" :style="colorPickerPosition">
                <chrome-picker v-model="color"/>
                <button type="button" class="btn" @click.prevent="color = {}">Clear Color</button>
            </div> 

        </div>-->
        <ul v-if="showIconPicker" ref="list" :style="{ 'height': height }">
            <li :class="[value ? null : 'selected','reset']" @click="resetValue">
                <FontAwesomeIcon icon="ban" @click="resetValue"/>
            </li>
            <li v-for="(filteredIcon,index) in filteredIcons" :key="index" :class="isSelected(filteredIcon) ? 'selected' : null"
                @click="updateSelectedIcon(filteredIcon)">
                <FontAwesomeIcon :icon="[filteredIcon.prefix,filteredIcon.iconName]"/>
            </li>
        </ul>
    </div>
</template>

<style scoped>
    /* .container {
        position: relative;
    } */
    ul {
        box-sizing: border-box;
        overflow-y: scroll;
        list-style: none;
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 10px;
        padding: 10px;
        margin: 0;
    }
    li {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
        margin: 5px;
        width: 20px;
        height: 20px;
        text-align: center;
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 50px;
        transition: all .2s ease-in-out;
    }
    li.reset {
        transition: none;
        color: red;
    }
    li.reset:hover, li.reset.selected {
        transform: none;
        background-color: red;
        color: white;
    }
    li:hover {
        background-color: #5a5a5a;
        color: white;
        cursor: pointer;
        transform: scale(2);
        border: 1px solid transparent;
    }
    li.selected {
        transform: scale(2);
        background-color: #1f8aff;
        color: white;
        border: none;
    }
    .search {
        margin-bottom: 5px;
        position: relative;
    }
    .icon-preview {
        /* cursor: pointer; */
        /* border: 1px solid rgba(0, 0, 0, .2); */
        border: 1px solid #ced4da;
        background-color: #e9ecef;
        padding: 10px;
        width: 35px;
        height: 38px;
        /* border-radius: 10px; */
    }
    .btn {
        color: white;
        width: 100%;
        vertical-align: middle;
        user-select: none;
        border: 1px solid transparent;
        padding: 5px;
        outline: none;
        box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3);
        background-color: #bd2130;
        cursor: pointer;
    }
    .btn:active {
        color: #fff;
        background-color: #900b18;
    }
</style>